import { useIntl } from 'react-intl';

import { CurrencyType } from '../../../enums/CurrencyType';

export const useOptions = () => {
  const intl = useIntl();

  return [
    {
      value: CurrencyType.Usd,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Usd',
        defaultMessage: 'United States Dollar',
        description: 'Currency label for USD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Usd.description',
        defaultMessage: 'USD ($)',
        description: 'Currency code and symbol for USD',
      }),
    },
    {
      value: CurrencyType.Aud,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Aud',
        defaultMessage: 'Australian Dollar',
        description: 'Currency label for AUD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Aud.description',
        defaultMessage: 'AUD ($)',
        description: 'Currency code and symbol for AUD',
      }),
    },
    {
      value: CurrencyType.Cad,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Cad',
        defaultMessage: 'Canadian Dollar',
        description: 'Currency label for CAD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Cad.description',
        defaultMessage: 'CAD ($)',
        description: 'Currency code and symbol for CAD',
      }),
    },
    {
      value: CurrencyType.Chf,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Chf',
        defaultMessage: 'Swiss Franc',
        description: 'Currency label for CHF',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Chf.description',
        defaultMessage: 'CHF (fr.)',
        description: 'Currency code and symbol for CHF',
      }),
    },
    {
      value: CurrencyType.Cny,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Cny',
        defaultMessage: 'Chinese Yuan (Renminbi)',
        description: 'Currency label for CNY',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Cny.description',
        defaultMessage: 'CNY (¥)',
        description: 'Currency code and symbol for CNY',
      }),
    },
    {
      value: CurrencyType.Dkk,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Dkk',
        defaultMessage: 'Danish Krone',
        description: 'Currency label for DKK',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Dkk.description',
        defaultMessage: 'DKK (kr.)',
        description: 'Currency code and symbol for DKK',
      }),
    },
    {
      value: CurrencyType.Eur,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Eur',
        defaultMessage: 'European Euro',
        description: 'Currency label for EUR',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Eur.description',
        defaultMessage: 'EUR (€)',
        description: 'Currency code and symbol for EUR',
      }),
    },
    {
      value: CurrencyType.Gbp,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Gbp',
        defaultMessage: 'Great Britain (UK) Pound',
        description: 'Currency label for GBP',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Gbp.description',
        defaultMessage: 'GBP (£)',
        description: 'Currency code and symbol for GBP',
      }),
    },
    {
      value: CurrencyType.Hkd,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Hkd',
        defaultMessage: 'Hong Kong Dollar',
        description: 'Currency label for HKD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Hkd.description',
        defaultMessage: 'HKD ($)',
        description: 'Currency code and symbol for HKD',
      }),
    },
    {
      value: CurrencyType.Ils,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Ils',
        defaultMessage: 'Israeli Shekel',
        description: 'Currency label for ILS',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Ils.description',
        defaultMessage: 'ILS (₪)',
        description: 'Currency code and symbol for ILS',
      }),
    },
    {
      value: CurrencyType.Inr,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Inr',
        defaultMessage: 'Indian Rupee',
        description: 'Currency label for INR',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Inr.description',
        defaultMessage: 'INR (₹)',
        description: 'Currency code and symbol for INR',
      }),
    },
    {
      value: CurrencyType.Jpy,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Jpy',
        defaultMessage: 'Japanese Yen',
        description: 'Currency label for JPY',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Jpy.description',
        defaultMessage: 'JPY (¥)',
        description: 'Currency code and symbol for JPY',
      }),
    },
    {
      value: CurrencyType.Krw,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Krw',
        defaultMessage: 'South Korean Won',
        description: 'Currency label for KRW',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Krw.description',
        defaultMessage: 'KRW (₩)',
        description: 'Currency code and symbol for KRW',
      }),
    },
    {
      value: CurrencyType.Mxn,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Mxn',
        defaultMessage: 'Mexican Peso',
        description: 'Currency label for MXN',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Mxn.description',
        defaultMessage: 'MXN ($)',
        description: 'Currency code and symbol for MXN',
      }),
    },
    {
      value: CurrencyType.Nok,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Nok',
        defaultMessage: 'Norwegian Krone',
        description: 'Currency label for NOK',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Nok.description',
        defaultMessage: 'NOK (kr)',
        description: 'Currency code and symbol for NOK',
      }),
    },
    {
      value: CurrencyType.Nzd,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Nzd',
        defaultMessage: 'New Zealand Dollar',
        description: 'Currency label for NZD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Nzd.description',
        defaultMessage: 'NZD ($)',
        description: 'Currency code and symbol for NZD',
      }),
    },
    {
      value: CurrencyType.Rub,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Rub',
        defaultMessage: 'Russian Ruble',
        description: 'Currency label for RUB',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Rub.description',
        defaultMessage: 'RUB (₽)',
        description: 'Currency code and symbol for RUB',
      }),
    },
    {
      value: CurrencyType.Sek,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Sek',
        defaultMessage: 'Swedish Krona',
        description: 'Currency label for SEK',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Sek.description',
        defaultMessage: 'SEK (kr)',
        description: 'Currency code and symbol for SEK',
      }),
    },
    {
      value: CurrencyType.Sgd,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Sgd',
        defaultMessage: 'Singapore Dollar',
        description: 'Currency label for SGD',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Sgd.description',
        defaultMessage: 'SGD ($)',
        description: 'Currency code and symbol for SGD',
      }),
    },
    {
      value: CurrencyType.Thb,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Thb',
        defaultMessage: 'Thailand Baht',
        description: 'Currency label for THB',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Thb.description',
        defaultMessage: 'THB (฿)',
        description: 'Currency code and symbol for THB',
      }),
    },
    {
      value: CurrencyType.Vnd,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Vnd',
        defaultMessage: 'Vietnamese Dong',
        description: 'Currency label for VND',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Vnd.description',
        defaultMessage: 'VND (₫)',
        description: 'Currency code and symbol for VND',
      }),
    },
    {
      value: CurrencyType.Zar,
      label: intl.formatMessage({
        id: 'Select.CurrencySelect.Zar',
        defaultMessage: 'South African Rand',
        description: 'Currency label for ZAR',
      }),
      description: intl.formatMessage({
        id: 'Select.CurrencySelect.Zar.description',
        defaultMessage: 'ZAR (R)',
        description: 'Currency code and symbol for ZAR',
      }),
    },
  ];
};
